<template>
    <StatusQuantity
        :percentage="actionPlansData.percentage"
        :open="actionPlansData.open"
        :in-progress="actionPlansData.in_progress"
        :completed="actionPlansData.completed"
        :others="actionPlansData.others"
    />
</template>

<script>
import StatusQuantity from '@/components/domain/ui/StatusQuantity.vue'

export default {
    name: 'AuditActionPlansCell',
    components: {
        StatusQuantity
    },
    props: {
        actionPlansData: {
            type: Object,
            required: false,
            default: () => ({
                percentage: 0,
                open: 0,
                in_progress: 0,
                completed: 0,
                others: 0
            })
        }
    }
}
</script>

<style lang="scss" scoped>
// Estilos ya definidos en StatusQuantity.vue
</style>

